
import About from "../../sections/AboutUs/About";
import Explore from "../../sections/Explore/Explore";
import Main from "../../sections/Main/Main";
import Outreach from "../../sections/Outreach/Outreach";
import Testimonials from "../../sections/Testimonials/Testimonials";
import Navbar from "../Navbar";
import ImportantNotice from "../ImportantNotice";

const Layout = () => {
  return (
    <>
      <Navbar />
      <ImportantNotice />
      <Main />
      <About />
      <Explore />

      <Testimonials />

      <Outreach />
    </>
  );
};

export default Layout;
